/**
 * News API Service - Direct JSON access
 * 
 * News items can have the following fields:
 * - id: Unique identifier for the news item
 * - title: The title of the news
 * - content: Text content of the news
 * - date: ISO datetime string
 * - important: Boolean flag for important news
 * - videoEmbed: URL to embed a YouTube video
 * - tweetUrl: Simple Twitter/X URL to a tweet (recommended method)
 * - tweetEmbed: HTML embed code for a Twitter tweet (legacy support)
 * - linkUrl: URL that will open when clicking on the news item
 */

// Path to the JSON file
const NEWS_DATA_URL = './news-data.json';

console.log('Using direct JSON data from:', NEWS_DATA_URL);

export const getAllNews = async () => {
  try {
    console.log('Fetching news from JSON file:', NEWS_DATA_URL);
    const response = await fetch(NEWS_DATA_URL, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache'
      }
    });
    
    if (!response.ok) {
      throw new Error(`Failed to load JSON file: ${response.status}`);
    }
    
    const data = await response.json();
    
    const sortedNews = [...data.news].sort((a, b) => 
      new Date(b.date).getTime() - new Date(a.date).getTime()
    );
    
    return {
      success: true,
      news: sortedNews,
      lastUpdated: data.lastUpdated || new Date().toISOString()
    };
  } catch (error) {
    console.error('Error fetching news data:', error);
    
    console.log('Falling back to static news data');
  }
};

export const getImportantNews = async () => {
  try {
    const result = await getAllNews();
    
    if (result.success) {
      const importantNews = result.news.filter(item => item.important === true);
      
      return {
        success: true,
        news: importantNews,
        lastUpdated: result.lastUpdated
      };
    } else {
      throw new Error('Failed to get news data');
    }
  } catch (error) {
    console.error('Error fetching important news:', error);
    throw error;
  }
};


export const getNewsById = async (id) => {
  try {
    if (!id || isNaN(parseInt(id))) {
      throw new Error('Invalid news ID');
    }
    
    // Get all news and find the specific item
    const result = await getAllNews();
    
    if (!result.success) {
      throw new Error('Failed to get news data');
    }
    
    const newsItem = result.news.find(item => item.id === parseInt(id));
    
    if (!newsItem) {
      throw new Error(`News item with ID ${id} not found`);
    }
    
    return {
      success: true,
      newsItem: newsItem
    };
  } catch (error) {
    console.error(`Error fetching news item with ID ${id}:`, error);
    throw error;
  }
};